import React from 'react';
import { HeaderCell, HeaderTitle } from './styled';

interface TableHeaderProps {
  title: string;
  paddingLeft?: string;
}

export const TableHeader = ({ title, paddingLeft }: TableHeaderProps) => {
  return (
    <HeaderCell style={paddingLeft ? { paddingLeft } : undefined}>
      <HeaderTitle>{title}</HeaderTitle>
    </HeaderCell>
  );
};
